var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "staff_page_wrapper" } },
    [
      _c("div", { staticClass: "bb-mobile-header" }, [
        _c("div", { staticClass: "bb-mobile-header-left" }, [
          _c(
            "button",
            {
              staticClass: "mobile-sidebar-btn",
              on: {
                click: function ($event) {
                  return _vm.openMobileAside()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "feather feather-menu",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                },
                [
                  _c("line", {
                    attrs: { x1: "3", y1: "12", x2: "21", y2: "12" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "6", x2: "21", y2: "6" },
                  }),
                  _c("line", {
                    attrs: { x1: "3", y1: "18", x2: "21", y2: "18" },
                  }),
                ]
              ),
            ]
          ),
        ]),
        _c("h1", [_vm._v(_vm._s(_vm.$t("staff.title")))]),
        _c("div", { staticClass: "bb-mobile-header-right" }, [
          _c(
            "button",
            {
              on: {
                click: function ($event) {
                  return _vm.openMobileStaffFilter()
                },
              },
            },
            [_c("i", { staticClass: "ki ki-more-ver" })]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between" },
        [
          _c("PlaceFilter"),
          _c(
            "button",
            {
              staticClass: "bb-btn btn-success btn-lg new-staff-btn",
              on: { click: _vm.createCalendar },
            },
            [_vm._v(" " + _vm._s(_vm.$t("staff.createStaffBtn")) + " ")]
          ),
        ],
        1
      ),
      _c("v-data-table", {
        ref: "staffTable",
        staticClass: "bb-table staff-table",
        attrs: {
          headers: _vm.tableHeaders,
          items: _vm.currentPlace.staff,
          "hide-default-footer": "",
          page: _vm.pagination.page,
          "items-per-page": _vm.pagination.itemsPerPage,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.pagination, "page", $event)
          },
          "page-count": function ($event) {
            _vm.pagination.pageCount = $event
          },
          pagination: function ($event) {
            return _vm.updatePaginationText($event)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "item.color",
            fn: function ({ item }) {
              return [
                _c("div", {
                  staticClass: "bb-badge badge-sm badge-rounded",
                  style: "background: " + item.calendar.color,
                }),
              ]
            },
          },
          {
            key: "item.id",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "table-action-buttons" }, [
                  _c(
                    "button",
                    {
                      staticClass: "table-action-button",
                      on: {
                        click: function ($event) {
                          return _vm.editWorkingHours(item.calendar)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-clock",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "10" },
                          }),
                          _c("polyline", {
                            attrs: { points: "12 6 12 12 16 14" },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "table-action-button",
                      on: {
                        click: function ($event) {
                          return _vm.editCalendar(item)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-edit",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "table-action-button",
                      on: {
                        click: function ($event) {
                          return _vm.deleteStaff(item)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "feather feather-trash-2",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        },
                        [
                          _c("polyline", { attrs: { points: "3 6 5 6 21 6" } }),
                          _c("path", {
                            attrs: {
                              d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
                            },
                          }),
                          _c("line", {
                            attrs: { x1: "10", y1: "11", x2: "10", y2: "17" },
                          }),
                          _c("line", {
                            attrs: { x1: "14", y1: "11", x2: "14", y2: "17" },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "bb-table-footer" },
        [
          _c("v-pagination", {
            staticClass: "bb-pagination",
            attrs: { length: _vm.pagination.pageCount },
            model: {
              value: _vm.pagination.page,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "page", $$v)
              },
              expression: "pagination.page",
            },
          }),
          _c(
            "div",
            {
              staticClass: "d-flex justufy-content-between align-items-center",
            },
            [
              _c("BBSelect", {
                staticClass: "bb-pagination-per-page-select",
                attrs: { options: _vm.pagination.perPageOptions },
                model: {
                  value: _vm.pagination.itemsPerPage,
                  callback: function ($$v) {
                    _vm.$set(_vm.pagination, "itemsPerPage", $$v)
                  },
                  expression: "pagination.itemsPerPage",
                },
              }),
              _c("span", { staticClass: "bb-table-pagination-text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("staff.table.pagination.show")) +
                    " " +
                    _vm._s(_vm.pagination.currentFromItem) +
                    " - " +
                    _vm._s(_vm.pagination.currentToItem) +
                    " " +
                    _vm._s(_vm.$t("staff.table.pagination.of")) +
                    " " +
                    _vm._s(_vm.pagination.currentTotalItems) +
                    " "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { id: "mobile_staff_wrapper" } }, [
        _c(
          "div",
          { staticClass: "staff-list" },
          _vm._l(_vm.currentPlace.staff, function (staffMember) {
            return _c(
              "div",
              {
                key: staffMember.id,
                staticClass: "staff-item",
                on: {
                  click: function ($event) {
                    return _vm.showMobileActions(staffMember)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start align-items-center",
                  },
                  [
                    _c("div", {
                      staticClass: "bb-badge badge-sm badge-rounded",
                      staticStyle: { flex: "0 0 auto" },
                      style: "background: " + staffMember.calendar.color,
                    }),
                    _c("div", { staticClass: "staff-details" }, [
                      _c("span", [_vm._v(_vm._s(staffMember.fullName))]),
                      _c("small", [_vm._v(_vm._s(staffMember.email))]),
                    ]),
                  ]
                ),
                _c("i", { staticClass: "la la-angle-right" }),
              ]
            )
          }),
          0
        ),
        _c(
          "button",
          {
            staticClass: "mobile-new-calendar-btn",
            on: { click: _vm.createCalendar },
          },
          [_c("i", { staticClass: "la la-plus" })]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.mobileActionsVisible,
                expression: "mobileActionsVisible",
              },
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.handleMobileActionsOutsideClick,
                expression: "handleMobileActionsOutsideClick",
              },
            ],
            staticClass: "mobile-actions-container",
            attrs: { id: "mobile_actions_container" },
          },
          [
            _c("div", { staticClass: "mobile-actions" }, [
              _c(
                "button",
                {
                  staticClass: "mobile-action-btn",
                  on: {
                    click: function ($event) {
                      _vm.editCalendar(_vm.selectedStaffMember)
                      _vm.hideMobileActions()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("staff.mobileButtons.editStaffBtn")) +
                      " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "mobile-action-btn",
                  on: {
                    click: function ($event) {
                      _vm.editWorkingHours(_vm.selectedStaffMember.calendar)
                      _vm.hideMobileActions()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("staff.mobileButtons.editWorkingHoursBtn")
                      ) +
                      " "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "mobile-action-btn danger",
                  on: {
                    click: function ($event) {
                      _vm.deleteStaff(_vm.selectedStaffMember)
                      _vm.hideMobileActions()
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("staff.mobileButtons.deleteStaffBtn")) +
                      " "
                  ),
                ]
              ),
            ]),
            _c(
              "button",
              {
                staticClass: "mobile-action-btn",
                on: {
                  click: function ($event) {
                    return _vm.hideMobileActions()
                  },
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("staff.mobileButtons.closeBtn")) + " "
                ),
              ]
            ),
          ]
        ),
      ]),
      _c("MobileStaffFilter"),
      _c("CalendarFormModal", { ref: "calendarFormModal" }),
      _c("AvailabilityFormModal", { ref: "availabilityFormModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }